<template>
  <section id="contact">
    <h2 class="numbered-heading overline">What's Next?</h2>
    <h2 class="title">Get In Touch</h2>
    <p>
      Although I'm not currently looking for any new opportunities, my inbox is
      always open. Whether you have a question or just want to say hi, I'll try
      my best to get back to you!
    </p>
    <a
      href="mailto:soumyadiphazra@gmail.com"
      class="email-link btn-glow-background">
      Say Hello
    </a>
    <a
      id="theme-toggler"
      href="#"
      class="theme-toggler">
      Switch to
      <!-- <i class="light-theme-icon fa fa-sun-o"></i> -->
      <font-awesome-icon
        icon="sun"
        class="light-theme-icon" />
      <i class="dark-theme-icon fa fa-moon-o"></i>
    </a>
  </section>
</template>

<script>
export default {
  name: 'GetInTouch',
  data () {
    return {}
  }
}
</script>

<style scoped>
</style>
